import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Experience from "./experience";
import Warranty from "./warranty";
import Consult from "./consult";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function BoardPro(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.board pro, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.board pro"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, board pro, neat board pro, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>All-in-One, AI</span> 화상회의 디바이스
        </div>
        <div className={style.device_title}>
          {isMobile ? (
            <img
              className={style.big_title}
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/device/neat/title_neat_board_pro_m.webp"
              }
              alt="boardpro"
            />
          ) : (
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/device/neat/title_neat_board_pro.webp"
              }
              alt="boardpro"
            />
          )}
        </div>
      </div>
      <div className={style.device_text}>
        중·대형 회의실 및 협진 환경에서
        <br />
        최적의 몰입감과 편리한 협업 경험을 제공하는{isMobile ? <br /> : " "}
        프리미엄 화상회의 장비
      </div>

      <div className={style.device_img_list}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/boardpro_1${isMobile ? "_m" : ""}.webp`
          }
          alt="boardpro"
        />
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/boardpro_2${isMobile ? "_m" : ""}.webp`
          }
          alt="boardpro"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div className={style.device_description_img_box}>
          <img
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/boardpro_device${isMobile ? "_m" : ""}.png`
            }
            alt="boardpro"
          />

          <div className={style.device_description_text_box}>
            테이블 스탠드 & 액티브 마커 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/camera${isMobile ? "_m" : ""}.webp`
                  }
                  alt="camera"
                />
              </div>
              <div className={style.device_description_text}>
                <span>듀얼 50MP 카메라 시스템</span> : 망원 렌즈와 광각 렌즈의
                결합으로 더욱 선명한 포착
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/high_quality${isMobile ? "_m" : ""}.webp`
                  }
                  alt="high_quality"
                />
              </div>
              <div className={style.device_description_text}>
                <span>4K 65인치 멀티터치 디스플레이</span>: 반사 방지 코팅이
                적용된 대형 스크린
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/audio${isMobile ? "_m" : ""}.webp`
                  }
                  alt="audio"
                />
              </div>
              <div className={style.device_description_text}>
                <span>고품질 오디오 시스템</span> : 음성 최적화 스테레오
                사운드와 5개의 마이크 배열
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_appHub_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/neat_app_hub${isMobile ? "_m" : ""}.webp`
                    }
                    alt="neat_app_hub"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Neat App Hub</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Board Pro <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_boardpro_1${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  강력한 디스플레이와 몰입형 회의 경험
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Board Pro는 65인치 멀티터치 디스플레이와 자연스럽게 적응하는 고성능 오디오 및${
                  isMobile ? " " : "\n"
                }` +
                  `비디오 시스템을 통해 더욱 몰입감 있는 회의 경험을 제공합니다. 하나의 우아한 디바이스로${
                    isMobile ? " " : "\n"
                  }` +
                  `확장 가능한 기능과 협업 애플리케이션을 지원하며, 초고속 이미지 처리 기능을 통해 회의실${
                    isMobile ? " " : "\n"
                  }` +
                  `내 모든 참가자를 위치나 움직임 방향에 관계없이 세밀하게 포착합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_boardpro_2${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  다양한 공간에 최적화된 최고의 다목적 디바이스
                </div>
              </div>
              <div className={style.device_features_text}>
                {`최첨단 기술과 유연한 설치 옵션을 갖춘 Neat Board Pro는 다양한 크기와 형태의${
                  isMobile ? " " : "\n"
                }` +
                  `공간에서도 탁월한 성능을 발휘합니다. 회의실, 협업 공간, 강의실 등${
                    isMobile ? " " : "\n"
                  }` +
                  `어디에서든 최적의 환경을 제공하는 가장 다재다능한 디바이스입니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_boardpro_3${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="feature3"
              /> */}
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_boardpro_3.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더욱 강력한 오디오·비디오 성능 및 확장성
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Board Pro는 자동으로 실내 음향, 소음, 조명 및 사용자의 움직임을 분석하여${
                  isMobile ? " " : "\n"
                }` +
                  `최적의 오디오·비디오 환경을 조성합니다. 또한 Neat의 다른 디바이스,${
                    isMobile ? " " : "\n"
                  }` +
                  `서드파티 오디오 장비, 추가 디스플레이를 손쉽게 연결하여${
                    isMobile ? " " : "\n"
                  }` +
                  `회의 환경을 더욱 확장할 수 있습니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_boardpro_4${isMobile ? "_m" : ""}.webp`
                }
                alt="feature4"
              /> */}
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_boardpro_4.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"4".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더 효율적인 협업을 위한 다양한 기능 제공
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Board Pro는 팀원들이 같은 공간에 있든 원격으로 연결되든 보다 효과적이고${
                  isMobile ? " " : "\n"
                }` +
                  `효율적인 협업을 지원합니다. 비디오 회의를 위한 전용 공간을 만들거나,${
                    isMobile ? " " : "\n"
                  }` +
                  `프레젠테이션, 워크숍, 브레인스토밍 등의 다양한 협업 환경을${
                    isMobile ? " " : "\n"
                  }` +
                  `보다 생동감 있게 구현할 수 있도록 다양한 기능을 제공합니다.`}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_mount_wrap}>
        <div className={style.device_mount_inner_box}>
          <div className={style.device_mount_title_wrap}>
            <div className={style.device_mount_title}>
              다양하고 유연한 설치 옵션
            </div>
            <div className={style.device_mount_text}>
              {isMobile ? (
                <>
                  적응형 스탠드 · 적응형 마운트 · 벽걸이형 ·
                  <br />
                  테이블 스탠드 등 사용자의 상황과 환경에 맞게
                  <br />
                  다양한 방법으로 설치가 가능합니다.
                </>
              ) : (
                <>
                  적응형 스탠드 · 적응형 마운트 · 벽걸이형 · 테이블 스탠드 등
                  <br />
                  사용자의 상황과 환경에 맞게 다양한 방법으로 설치가 가능합니다.
                </>
              )}
            </div>
          </div>
          <div className={style.device_mount_type_grid}>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{ backgroundColor: "#121212" }}
                >
                  <span style={{ color: "#ffffff" }}>적응형 스탠드</span>
                </div>
                <div className={style.device_mount_type_text}>
                  독특한 적응형 스탠드는 회의에 더 큰 접근성과 자유를
                  가져다줍니다. Neat Board Pro를 공간에서 공간으로 옮길 수
                  있으며, 누구나 최적의 사용과 시청을 위해 화면을 위아래로
                  조정할 수 있습니다.
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_stand_adaptive_boardpro${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="stand_adaptive"
              />
            </div>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{ backgroundColor: "#121212" }}
                >
                  <span style={{ color: "#ffffff" }}>적응형 마운트</span>
                </div>
                <div className={style.device_mount_type_text}>
                  적응형 마운트를 사용하면 Neat Board Pro를 벽에 꼭 맞게
                  배치하여 방 전체가 세련되게 보이고 최적의 사용과 시청을 위해
                  화면을 위아래로 조정할 수 있습니다.
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_wall_adaptive_boardpro${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="wall_adaptive"
              />
            </div>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{ backgroundColor: "#121212" }}
                >
                  <span style={{ color: "#ffffff" }}>벽걸이형</span>
                </div>
                <div className={style.device_mount_type_text}>
                  벽면 거치대는 VESA와 호환되므로 Neat Board Pro를 벽에 꼭 맞게
                  설치하여 방을 세련되게 만들 수 있습니다.
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_wall_boardpro${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="wall"
              />
            </div>
            <div className={style.device_mount_type_item}>
              <div className={style.device_mount_type_title_wrap}>
                <div
                  className={style.device_mount_type_title}
                  style={{ backgroundColor: "#121212" }}
                >
                  <span style={{ color: "#ffffff" }}>테이블 스탠드</span>
                </div>
                <div className={style.device_mount_type_text}>
                  테이블 스탠드는 미니멀리스트 디자인의 일부로 Neat Board Pro와
                  함께 제공됩니다. 나사가 없으므로 제자리에 끼우는 것이 빠르고
                  쉽습니다.
                </div>
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mount_stand_table_boardpro${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="table"
              />
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_boardpro_1${isMobile ? "_m" : ""}.webp`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_2${isMobile ? "_m" : ""}.webp`
                }
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_3${isMobile ? "_m" : ""}.webp`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_text_wrap}
          style={{ borderRadius: "20px 20px 0 0" }}
        >
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>65인치 정전식 멀티터치 LCD 화면</span>
                <span>Ultra HD 4K(3840 x 2160 화면 해상도)</span>
                <span>16:9 종횡비</span>
                <span>눈부심 방지 코팅</span>
                <span>유리 표면 경도 7H</span>
                <span>USB-C 90W 전원 공급</span>
                <span>2차 디스플레이 지원</span>
                <span>카메라 LED</span>
                <span>시스템 LED</span>
                <span>주변광 센서</span>
                <span>온도, 습도 및 공기 질 센서 (*)</span>
                <span>Neat Active Marker</span>
                <span>테이블 스탠드</span>
                <span>적응형 스탠드(옵션)</span>
                <span>적응형 마운트(옵션)</span>
                <span>벽면 마운트(옵션)</span>
                <span>Neat Pad 컨트롤러(옵션)</span>
                <span>Neat Pad 스케줄링 디스플레이(옵션)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "17px" }}
            >
              <div className={style.device_spec_text_label}>
                전기 및{isMobile ? " " : <br />}환경{isMobile ? " " : <br />}
                요구사항
              </div>
              <div className={style.device_spec_text}>
                <span>100-240V ~ 50/60Hz 4.5A</span>
                <span>주변 작동 온도: 32° ~ 95° F (0° ~ 35° C)</span>
                <span>보관 온도: -4° ~ 140° F (-20° ~ 60° C)</span>
                <span>상대 습도: 10% ~ 90%</span>
                <span>내장 전원 공급 장치</span>
                <div className={style.device_spec_power_wrap}>
                  <div className={style.device_spec_power_title}>전력 소모</div>
                  <div className={style.device_spec_power_text}>
                    <span>대기: 128W</span>
                    <span>대기 화면 꺼짐: 13.2W</span>
                    <span>통화 중: 135W</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>
                  Pro 100 MP 카메라 시스템, 와이드 및 텔레 카메라 포함
                </span>
                <span>와이드 카메라: 50 MP, ƒ/2.8 조리개, 113° 수평 시야</span>
                <span>망원 카메라: 50 MP, ƒ/1.8 조리개, 70° 수평 시야</span>
                <span>최대 16배 하이브리드 줌</span>
                <span>고정 렌즈, 무한 초점</span>
                <span>자동 사람 프레이밍</span>
                <span>하드웨어 가속 비디오 인코딩 및 디코딩</span>
                <span>왜곡 보정 | 노이즈 감소</span>
                <span>색수차 보정</span>
                <span>자동 화이트 밸런스 및 색상 보정</span>
                <span>사람 비디오 해상도: 최대 1080p/30</span>
                <span>콘텐츠 비디오 해상도: 720p/60, 1080p/30</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>
                  최소한의 왜곡으로 최대 음조 범위를 제공하는 스피커 박스
                </span>
                <span>
                  지향성 및 스테레오 사운드를 위한 3개의 풀 레인지 스피커
                </span>
                <span>진동 제거를 위한 2개의 반대 드라이버가 있는 우퍼</span>
                <span>5개의 센서 마이크</span>
                <span>엔드파이어 어레이로 각도가 조정된 5개의 마이크</span>
                <span>하드웨어 가속 오디오 처리</span>
                <span>무선 콘텐츠 공유를 위한 초음파 지원</span>
                <span>에코 제거</span>
                <span>소음 억제</span>
                <span>자동 이득 제어</span>
                <span>반향 제거</span>
              </div>
            </div>
          </div>
        </div>

        <div className={style.device_spec_mount_wrap}>
          <div className={style.device_spec_mount_horizon}></div>
          <div className={style.device_spec_mount_title}>
            Neat Board Pro Mount
          </div>

          <div className={style.device_spec_mount_list}>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                테이블 스탠드가 포함된{isMobile ? <br /> : " "}Neat Board Pro
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_mount_1${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_1"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>폭: 57.9인치(1470mm)</span>
                  <span>높이: 37.2인치(945mm)</span>
                  <span>깊이: 12.7인치(322mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 96.6파운드(43.8kg)</span>
                  <span>테이블 스탠드의 순중량: 2.8파운드(1.24kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                벽면 장착형 Neat Board Pro{isMobile && <br />}(옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_mount_2${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_2"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 57.9인치(1470mm)</span>
                  <span>높이: 36인치(915mm)</span>
                  <span>깊이: 3.6인치(91mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 110.3파운드(50kg)</span>
                  <span>벽면 장착형 순중량: 16.6파운드(7.5kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                적응형 마운트(옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_mount_3${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_3"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>너비: 57.9인치(1470mm)</span>
                  <span>높이: 36인치(915mm)</span>
                  <span>깊이: 3.7인치(95mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 131.2파운드(59.5kg)</span>
                  <span>적응형 마운트의 순중량: 37.3파운드(45.5kg)</span>
                </div>
              </div>
            </div>
            <div className={style.device_spec_mount_item}>
              <div className={style.device_spec_mount_item_title}>
                어댑터 스탠드 (옵션)
              </div>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_boardpro_mount_4${
                    isMobile ? "_m" : ""
                  }.webp`
                }
                alt="mount_4"
              />
              <div className={style.device_spec_mount_text_wrap}>
                <div className={style.device_spec_mount_text_group}>
                  <span>폭: 57.9인치(1470mm)</span>
                  <span>최소 높이: 68.9인치(1750mm)</span>
                  <span>최대 높이: 74인치(1878mm)</span>
                  <span>깊이: 36인치(915mm)</span>
                </div>
                <div className={style.device_spec_mount_text_group}>
                  <span>무게: 194파운드(88kg)</span>
                  <span>적응형 스탠드의 순중량: 100.3파운드(45.5kg)</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/spec_board50_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>65″</div>
            <div className={style.device_spec_icon_label}>4K 액티브 터치</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>113° FOV</div>
            <div className={style.device_spec_icon_label}>광각 카메라</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50MP</div>
            <div className={style.device_spec_icon_label}>캡처 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>16x</div>
            <div className={style.device_spec_icon_label}>
              최대 16배{isMobile ? <br /> : " "}하이브리드 줌
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.micArray_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mic_array${isMobile ? "_m" : ""}.webp`
                }
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>5 마이크 어레이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>3</div>
            <div className={style.device_spec_icon_label}>풀 레인지 스피커</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.activeMarker_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/active_marker${isMobile ? "_m" : ""}.webp`
                }
                alt="active_marker"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              깔끔한 액티브 마커
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.hdmi_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/hdmi${isMobile ? "_m" : ""}.webp`
                }
                alt="hdmi"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              듀얼 스크린을 위한 HDMI
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.air_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/air${isMobile ? "_m" : ""}.webp`
                }
                alt="air"
              />
            </div>
            <div className={style.device_spec_icon_label}>공기질 센서</div>
          </div>
        </div>

        <Warranty />
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default BoardPro;
